<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import prospectService from '@/src/services/api-receituario/prospect'
import { mask } from 'vue-the-mask'

/**
 * Register Prospect Component
 */
export default {
  components: {
    Layout,
    Loading,
  },
  directives: { mask },
  props: {
    id: '',
  },
  data() {
    return {
      isLoading: false,
      prospect: {},
    }
  },
  computed: {},
  watch: {},
  mounted() {
    const script = document.createElement("script");
    script.src = "https://res.cloudinary.com/das1rnjvi/raw/upload/v1674582202/bluelogic/v2_x8uau3.js";
    document.body.appendChild(script);
    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "8761732",
          formId: "6eef5d36-5bfe-4955-b4ff-5bcba871661d",
          target: '#hs-form'
        })
      }
    })  
  },
  methods: {
    save() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      prospectService
        .salvar(token, this.prospect)
        .then((resposta) => {
          this.isLoading = false
          this.$bvModal.hide(this.id)
          if (!resposta.data.sucesso) {
            this.$bvToast.toast(resposta.data.mensagem, {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          } else {
            this.$bvToast.toast('Solicitação enviada com sucesso!', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          }
          this.prospect = {}
        })
        .catch((erro) => {
          this.isLoading = false
          this.$bvToast.toast(
            erro.response
              ? erro.response.data.data.join(', ')
              : 'Erro inesperado',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
    },
  },
}
</script>
<template>
  <Layout>
    <div class="bloco">
      <div>
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Suporte</div>
            <div class="subTitulo">Registre sua solicitação para atendimento da nossa equipe.</div>
          </div>
          <div class="col-md-1">
            <div class="float-right">

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div v-once id="hs-form"></div>
          </div>
        </div>

        <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
      </div>
    </div>
  </Layout>

</template>
<style lang="scss">
.container-pai {
  height: 600px;
  width: 100%;
  background-color: gray;
}

.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subtitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>